exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.file-dropper-overlay.dropper-background-overlay{position:absolute;opacity:0;left:0;top:0;width:100%;height:100%;background:linear-gradient(rgba(0,0,0,0.6), white);border-radius:15px;border:5px dashed #000;box-sizing:border-box;visibility:hidden}div.file-dropper-overlay.dropper-text-overlay{position:absolute;opacity:0;left:0;top:0;width:100%;background-color:#379AFF;padding:1.5rem 0;font-size:21px;text-align:center;word-break:break-all;color:#fafafa}div.file-dropper-overlay.visible-drop-overlay{display:block !important;opacity:1 !important}div.file-dropper-overlay{z-index:10000}\n", ""]);

// exports
